import { useEffect } from 'react';
import { qontoWebsocket } from '@repo/runtime-kit/websocket/websocket';

interface UseQontoWebsocketConnectionOptions {
  websocketBaseURL: string;
  token: string;
  userId: string;
  onError?: (error: unknown) => void;
}

/**
 * Establishes a WebSocket connection using qontoWebsocket.connect().
 * The connection is automatically disconnected when the component unmounts. Event listeners are
 * preserved so they remain active after a reconnect, for example after a session token refresh.
 *
 * This hook should be used in applications where the WebSocket
 * connection is not already globally established.
 *
 */
export function useQontoWebsocketConnection({
  websocketBaseURL,
  token,
  userId,
  onError,
}: UseQontoWebsocketConnectionOptions) {
  useEffect(() => {
    if (!token || !userId) return;

    try {
      qontoWebsocket.connect({
        websocketBaseURL,
        token,
        userId,
      });
    } catch (error) {
      onError?.(error);
    }

    return () => {
      qontoWebsocket.disconnect({ preserveListeners: true });
    };
  }, [websocketBaseURL, token, userId, onError]);
}
